import { AuthGuard, CrudOp, projectManagementAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";
import { useParams } from "react-router-dom";

export const OperatorView: FC = () => {
  const { projectId, subprojectId } = useParams();
  if (projectId == null || subprojectId == null) {
    throw new Error("not in a subproject");
  }

  return (
    <AuthGuard authScope={projectManagementAuthScope} crudOp={CrudOp.READ} project={projectId}>
      <Suspense><LazyOperatorView projectId={projectId} subprojectId={subprojectId}/></Suspense>
    </AuthGuard>
  );
};

const LazyOperatorView = lazy(importView(
  () => import("../components/OperatorView"),
  (it) => it.OperatorView,
));
